module.exports = __webpack_public_path__ + "static/media/otsGraph.cb1c30ee.jpg";